module.exports = __webpack_public_path__ + "img/aboutCYT1.9296028f.jpg";